/* eslint-disable */
import { useContext } from 'react'
import { Dialog, DialogTitle, DialogContent, LinearProgress } from '@mui/material'
import { DataGrid } from '@mui/x-data-grid'
import { OrgAppContext } from '../../OrgAppContext'
import { getProviderLabel } from '../../utils/provider'
import dayjs from 'dayjs'

interface LogListProps {
  open: boolean
  onClose: () => void
  logs: any[]
  isLoading?: boolean
}

function LogList({ open, onClose, logs, isLoading = false }: LogListProps) {
  const { customerId } = useContext(OrgAppContext)

  const columns = [
    {
      field: 'datetime',
      headerName: 'Time',
      flex: 0.7,
      wrapText: true,
      renderCell: (params: any) => <div>{dayjs(params.value).format('YYYY-MM-DD HH:mm:ss')}</div>,
    },
    { field: 'eventType', headerName: 'Event Type', flex: 0.6, wrapText: true },
    { field: 'clientId', headerName: 'Client Id', flex: 0.6, wrapText: true },
    { field: 'clientName', headerName: 'Client Name', flex: 0.7, wrapText: true },
    { field: 'clientService', headerName: 'Client Service', flex: 2, wrapText: true },
    { field: 'providerId', headerName: getProviderLabel(customerId, 'id'), flex: 0.7, wrapText: true },
    { field: 'providerName', headerName: getProviderLabel(customerId, 'name'), flex: 0.8, wrapText: true },
    { field: 'providerService', headerName: getProviderLabel(customerId, 'service'), flex: 1, wrapText: true },
  ]

  return (
    <Dialog
      open={open}
      onClose={onClose}
      PaperProps={{
        style: {
          maxWidth: '95vw',
        },
      }}
    >
      <DialogTitle style={{ color: '#000000', fontSize: '16px', fontWeight: 'bold' }}>
        Log Details
      </DialogTitle>
      <DialogContent sx={{ maxHeight: '70vh' }}>
        <DataGrid
          autoHeight
          hideFooter
          slots={{
            loadingOverlay: LinearProgress,
          }}
          getRowHeight={() => 'auto'}
          loading={isLoading}
          columns={columns}
          rows={logs || []}
          localeText={{ noRowsLabel: 'Nothing to display :)' }}
          sx={{
            border: 'none',
            '& .MuiDataGrid-row:hover': {
              backgroundColor: 'rgba(235, 235, 235, 0.7)',
            },
            '& .MuiDataGrid-columnHeaders': {
              backgroundColor: '#ECECEC',
              color: '#5B5B5B',
              fontSize: '13px',
              borderBottom: '2px solid #BABABA',
            },
            '& .MuiDataGrid-cell': {
              borderBottom: `1px solid #BABABA`,
              color: '#000000',
              fontSize: '12px',
              cursor: 'pointer',
              fontWeight: '500',
              wordWrap: 'break-word',
              py: 1,
            },
            '& .MuiDataGrid-columnSeparator': {
              display: 'none',
            },
            '& ::-webkit-scrollbar': {
              width: '5px',
            },
            '& ::-webkit-scrollbar-track': {
              backgroundColor: '#f1f1f1',
            },
            '& ::-webkit-scrollbar-thumb': {
              backgroundColor: '#888',
              borderRadius: '5px',
              '&:hover': {
                backgroundColor: '#555',
              },
            },
            minHeight: '300px',
            width: '90vw',
          }}
        />
      </DialogContent>
    </Dialog>
  )
}

export default LogList
